<template>
  <div class="fill-height of-y d-flex flex-column">
    
    <template v-if="loading">
      <div class="d-flex fill-height align-center justify-center">
        <loader :size="36"></loader>
      </div>
    </template>
    
    <template v-else>
      <div class="flex-grow-0 pa-2 d-flex justify-space-between">
        <v-btn
            :disabled="loading"
            @click="getUnderPerformerData"
            color="primary"
            small
            :loading="loading"
            class="mx-1"
        >
          Refresh
        </v-btn>
        <v-btn
            class="mx-1"
            :disabled="!this.selectedFarm"
            @click="showRangeSelect = true"
            color="primary"
            small
        >
          Date Range Export
        </v-btn>
        <v-btn
            class="mx-1"
            :disabled="false"
            @click="exportReportData"
            color="primary"
            small
            :loading="exportingData"
        >
          Export
        </v-btn>
        <div class="flex-grow-1">
        
        </div>
        <div style="width: 30%">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="pa-0 ma-0"
          ></v-text-field>
        </div>
        <!--                <div>-->
        <!--                    <v-btn-->
        <!--                            icon-->
        <!--                            color="primary"-->
        <!--                            class="pa-0 mr-2"-->
        <!--                            @click="$emit('update:selected-date', subDays(selectedDate, 1))"-->
        <!--                    >-->
        <!--                        <v-icon>mdi-chevron-left</v-icon>-->
        <!--                    </v-btn>-->
        <!--                    <v-btn-->
        <!--                            icon-->
        <!--                            color="primary"-->
        <!--                            class="pa-0 mr-2"-->
        <!--                            @click="$emit('update:selected-date', addDays(selectedDate, 1))"-->
        <!--                    >-->
        <!--                        <v-icon>mdi-chevron-right</v-icon>-->
        <!--                    </v-btn>-->
        <!--                </div>-->
      </div>
      <div class="flex-grow-0">
        
        <v-card class="ma-2">
          <v-data-table
              dense
              hide-default-footer
              :headers="targetHeaders"
              :items="filteredTargets"
              :options="{itemsPerPage: targets.length}"
          >
            <template #item.date="{item}">
              <span class="caption" style="white-space: nowrap">{{format(item.date, 'yyyy-MM-dd')}}</span>
            </template>
            
            <template #item.farmDescription="{item}">
              <span class="caption">{{item.farmDescription}}</span>
            </template>
            
            <template #item.varietyDescription="{item}">
              <span class="caption">{{item.varietyDescription}}</span>
            </template>
            
            <template #item.target="{item}">
              <v-text-field
                  type="number"
                  solo
                  hide-details
                  v-model.number="item.provisionalTarget"
                  style="width: 100px"
                  :background-color="item.provisionalTarget && item.provisionalTarget !== item.target ? 'amber darken-2' : (item.provisionalTarget && item.provisionalTarget === item.target ? undefined : 'error')"
              >
              
              </v-text-field>
            </template>
            
            <template #item.status="{item}">
              
              
              
              <v-tooltip top v-if="item.provisionalTarget && item.provisionalTarget !== item.target">
                <template #activator="{on}">
                  <v-icon
                      v-on="on"
                      color="amber darken-1"
                  >mdi-alert</v-icon>
                </template>
                Save changes to apply
              </v-tooltip>
              
              <v-tooltip top v-else-if="item.provisionalTarget && item.provisionalTarget === item.target">
                <template #activator="{on}">
                  <v-icon
                      v-on="on"
                      color="green darken-1"
                  >mdi-check</v-icon>
                </template>
                Target Captured
              </v-tooltip>
              
              <v-tooltip top v-else>
                <template #activator="{on}">
                  <v-icon
                      v-on="on"
                      color="error"
                  >mdi-alert-circle</v-icon>
                </template>
                Capture Target
              </v-tooltip>
            </template>
            
            <template #item.totalHoursWorked="{item}">
              {{Math.round(item.totalHoursWorked * 100) / 100}}
            </template>
            <template #item.totalBins="{item}">
              {{Math.round(item.totalBins)}}
            </template>
            <template #item.avgProductionUnitsPerEmployeePerDay="{item}">
              {{Math.round(item.avgProductionUnitsPerEmployeePerDay * 100) / 100}}
            </template>
          
          </v-data-table>
          <v-divider></v-divider>
          <div class="d-flex justify-end pa-2">
            <v-btn @click="resetTargets" small color="grey" text class="mx-1">Reset</v-btn>
            <v-btn :disabled="!targetSaves.length" small color="primary" class="mx-1" @click="saveTargets">Save Changes</v-btn>
          </div>
        </v-card>
        
        
      </div>
      
      <div class="flex-grow-1 of-y pa-2">
        
        <v-card class=" fill-height">
          <v-data-table
              fixed-header
              height="100%"
              class="fill-height of-y"
              dense
              hide-default-footer
              :headers="employeeHeaders"
              :items="filteredEmployees"
              :options="{itemsPerPage: employees.length}"
          >
            
            <template #item.farmDescription="{item}"><span class="caption">{{item.farmDescription}}</span></template>
            <template #item.varietyDescription="{item}"><span class="caption">{{item.varietyDescription}}</span></template>
            <template #item.employeeDescription="{item}"><span class="caption">{{item.employeeDescription}}</span></template>
            
            <template #item.hoursWorked="{item}">
              {{Math.round(item.hoursWorked * 100) / 100}}
            </template>
            
            <template #item.totalBins="{item}">
              {{Math.round(item.totalBins * 10) / 10}}
            </template>
<!--            <template #item.totalBins="{item}">-->
<!--              {{Math.round(item.totalBins)}}-->
<!--            </template>-->
            <template #item.employeeProductionUnitsPerDay="{item}">
              {{Math.round(item.employeeProductionUnitsPerDay * 100) / 100}}
            </template>
            
            <template #item.productionVsTarget="{item}">
              {{item.productionVsTarget !== 'N/A' ? Math.round(item.productionVsTarget) + "%" : 'N/A'}}
            </template>
<!--            -->
            <template #item.productionVsAvg="{item}">
              {{item.productionVsAvg !== 'N/A' ? Math.round(item.productionVsAvg) + "%" : 'N/A'}}
            </template>
          
          </v-data-table>
        </v-card>
      
      
      </div>
    </template>
    
    <!-- Date Range Selection Dialog -->
    <v-dialog v-model="showRangeSelect" max-width="500px">
      <v-card>
        <v-card-title>
          Select Date Range
        </v-card-title>
        <v-card-text>
          <v-container v-if="!enterRangeVarieties">
            <v-row>
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="rangeStart"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="rangeStart"
                    @input="startDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="rangeEnd"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="rangeEnd"
                    @input="endDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
          
          <!-- Variety Targets Section -->
          <v-container v-else>
            <div class="text-h6 mb-4">Enter targets for each variety</div>
            <v-row v-if="loadingRangeVarieties">
              <v-col cols="12" class="text-center">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Variety</th>
                        <th class="text-left">Target</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="variety in rangeVarieties" :key="variety.varietyId">
                        <td>{{ variety.varietyDescription }}</td>
                        <td>
                          <v-text-field
                            v-model.number="variety.target"
                            type="number"
                            hide-details
                            dense
                            solo
                            flat
                            min="0"
                            style="max-width: 150px"
                          ></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            @click="showRangeSelect = false"
          >
            Cancel
          </v-btn>
          <v-btn
              v-if="!enterRangeVarieties"
              color="primary"
              :disabled="!rangeStart || !rangeEnd"
              :loading="loadingRangeVarieties"
              @click="getVarietiesForRange()"
          >
            Next
          </v-btn>
          <v-btn
              v-else
            color="primary"
            :disabled="!rangeStart || !rangeEnd"
            :loading="exportingRangeData"
            @click="exportRangeData"
          >
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>

import {addDays, format, subDays} from "date-fns";
import {mapGetters} from "vuex";
import Loader from "../General/Loader/Loader";
import ModifyWarning from "@/components/Setup/Warnings/ModifyWarning.vue";

export default {
  components: {ModifyWarning, Loader},
  props: {
    selectedFarm: Number,
    selectedDate: Date
  },
  data() {
    return {
      search: null,
      
      targetHeaders: [
        {value: "status"},
        {text: "Date", value: "date"},
        {text: "Farm", value: "farmDescription"},
        {text: "Variety", value: "varietyDescription"},
        {text: "Total Employees", value: "totalEmployees"},
        {text: "Total Hours", value: "totalHoursWorked"},
        {text: "Total Bins", value: "totalBins"},
        {text: "Avg Production", value: "avgProductionUnitsPerEmployeePerDay"},
        {text: "Production Target", value: "target"},
      ],
      employeeHeaders: [
        {text: "Farm", value: "farmDescription"},
        {text: "Variety", value: "varietyDescription"},
        {text: "Employee", value: "employeeDescription"},
        {text: "Emp Code", value: "empCode"},
        {text: "Hours Worked", value: "hoursWorked"},
        {text: "Total Bins", value: "totalBins"},
        {text: "Emp Production", value: "employeeProductionUnitsPerDay"},
        {text: "Prod vs Avg", value: "productionVsAvg"},
        {text: "Prod vs Target", value: "productionVsTarget"},
      ],
      
      
      t: {
        "farmDescription": "Mahela Letsitele",
        "varietyDescription": "STAR RUBY",
        "employeeDescription": "IGLET MOKGADI MOAGI",
        "empCode": "4034",
        "fkFarm": 79,
        "fkVariety": 508,
        "empID": "48925",
        "lastBin": "2024-05-01T13:43:17.000Z",
        "totalBins": 1.3333,
        "clockIn": "2024-05-01T07:16:49.000Z",
        "hoursWorked": 6.4411,
        "employeeProductionUnitsPerDay": 1.86298924,
        "productionVsAvg": 97.075772734943,
        "productionVsTarget": "N/A"
      },
      addDays: addDays,
      subDays: subDays,
      exportingData: false,
      loading: false,
      targets: [],
      employees: [],
      captureItem: null,
      captureValue: null,
      showRangeSelect: false,
      rangeVarieties: null,
      enterRangeVarieties: false,
      loadingRangeVarieties: false,
      rangeStart: null,
      rangeEnd: null,
      startDateMenu: false,
      endDateMenu: false,
      exportingRangeData: false,
    }
  },
  mounted() {
    if (this.selectedFarm && this.selectedDate)
      this.getUnderPerformerData()
  },
  watch: {
    showRangeSelect(val) {
      this.rangeVarieties = null;
      this.loadingRangeVarieties = false;
      this.enterRangeVarieties = false;
    },
    selectedFarm(val) {
      if (val) {
        this.getUnderPerformerData()
      }
    },
    selectedDate: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getUnderPerformerData()
        }
      }
    }
  },
  methods: {
    format,
    
    resetTargets() {
      for (const target of this.targets)
        target.provisionalTarget = target.target || 0
    },
    
    async getUnderPerformerData() {
      
      this.targets = [];
      this.employees = [];
      
      try {
        this.loading = true;
        const data = await this.$newReq('POST', `reports/underPerformers`, {start: this.selectedDate})
        
        this.targets = data.targets.map(v => ({
          ...v,
          date: new Date(v.date),
          target: v.target || 0,
          provisionalTarget: v.target || 0
        }))
        
        this.employees = data.employees.map(v => ({
          ...v,
          date: new Date(v.date),
        }))
        
        console.log(data)
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError();
      } finally {
        this.loading = false
      }
    },
    exportReportData() {
      this.exportingData = true;
      this.$newReqDownloadFile(
          'POST',
          `reports/underPerformers/export`,
          {
            start: this.selectedDate,
            selectedFarm: this.selectedFarm
          },
          `Under Performers Export ${format(new Date(this.selectedDate), 'yyyy-MM-dd')}.xlsx`
      )
          .then(data => {
            console.log(data)
          })
          .catch(e => {
            console.log(e)
            this.$snack.netWorkError();
          })
          .finally(() => {
            this.exportingData = false
          })
    },
    async saveTargets() {
      try {
        this.loading = true;
        await this.$newReq('POST', `reports/underPerformers/captureTargets`, {targets: this.targetSaves})
        await this.getUnderPerformerData()
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.loading = false;
      }
    },
    
    async getVarietiesForRange() {
      try {
        this.loadingRangeVarieties = true;
        this.rangeVarieties = await this.$newReq('POST', `reports/underPerformers/range/getVarieties`, {
          start: this.rangeStart, 
          end: this.rangeEnd, 
          farmId: this.selectedFarm
        })
        this.enterRangeVarieties = true;
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError();
      } finally {
        this.loadingRangeVarieties = false;
      }
    },
    
    exportRangeData() {
      this.exportingRangeData = true;
      this.$newReqDownloadFile(
          'POST',
          `reports/underPerformers/range/export`,
          {
            startDate: this.rangeStart,
            endDate: this.rangeEnd,
            selectedFarm: this.selectedFarm,
            varietyTargets: this.rangeVarieties
          },
          `Under Performers Export ${format(new Date(this.rangeStart), 'yyyy-MM-dd')} to ${format(new Date(this.rangeEnd), 'yyyy-MM-dd')}.xlsx`
      )
          .then(data => {
            console.log(data)
            this.showRangeSelect = false;
            this.rangeStart = null;
            this.rangeEnd = null;
            this.rangeVarieties = null;
            this.enterRangeVarieties = false;
          })
          .catch(e => {
            console.log(e)
            this.$snack.netWorkError();
          })
          .finally(() => {
            this.exportingRangeData = false
          })
    }
  },
  computed: {
    ...mapGetters(['farmsRef']),
    farm() {
      return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null
    },
    
    targetSaves() {
      return this.targets.filter(v => v.provisionalTarget && v.provisionalTarget !== v.target)
    },
    
    filteredTargets() {
      return (this.selectedFarm ? this.targets.filter(val => val.farmId === this.selectedFarm) : [...this.targets])
          .sort((a,b) => {
            if (a.farmId === b.farmId)
              return a.varietyDescription > b.varietyDescription ? 1 : -1
            return a.farmDescription > b.farmDescription ? 1 : -1
          })
    },
    
    filteredEmployees() {
      return (this.selectedFarm ? this.employees.filter(val => val.fkFarm === this.selectedFarm) : [...this.employees])
          .sort((a,b) => {
            if (a.fkFarm === b.fkFarm)
              return a.varietyDescription > b.varietyDescription ? 1 : -1
            return a.farmDescription > b.farmDescription ? 1 : -1
          })
    }
    
    // rows() {
    //     return this.data.map(row => {
    //         return {
    //             farmID: row.farm.id,
    //             farm: row.farm.description,
    //             employee: row.emp.fullName,
    //             empCode: row.emp.empCode,
    //             clockIn: row.clockInStr,
    //             lastAction: row.lastActionStr,
    //             binUnits: row.binUnits,
    //             piecework: row.pieceWorkStr,
    //             pWUnits: row.pieceWorkUnits,
    //             hours: row.hours,
    //         }
    //     }).filter((row) => this.selectedFarm ? row.farmID === this.selectedFarm : true)
    // }
  },
}
</script>

<style scoped>

</style>